var map = {
	"./COLORI-AVVERTENZED.png": 2820,
	"./Farmadati_logo.jpg": 8119,
	"./Farmadati_logo_2.jpg": 7709,
	"./Group.png": 8657,
	"./Polygon.png": 4730,
	"./Rectanglegreen.png": 7482,
	"./Rectanglered.png": 3121,
	"./Rectangleredpng.png": 8390,
	"./Salva.png": 1730,
	"./Vector.png": 6319,
	"./add-file.png": 4313,
	"./aggiunta-add.png": 8290,
	"./aggiunta.png": 4983,
	"./aggiuntaLight.png": 5764,
	"./aggiuntaOrange.png": 8635,
	"./aggiuntaRed.png": 8194,
	"./aggiuntaYellow.png": 835,
	"./aiuto.png": 4819,
	"./allegato.png": 8184,
	"./arrow-down.svg": 1313,
	"./btn-1.png": 4397,
	"./caduceo.png": 790,
	"./delete.png": 9936,
	"./direct-download.png": 4158,
	"./email.png": 908,
	"./erase.png": 3602,
	"./freccia-grande-tendina.png": 2089,
	"./gitignore.png": 1945,
	"./google-icon.png": 1327,
	"./info-aggiuntive.png": 1319,
	"./info.png": 5451,
	"./lente-barra-ricerca.png": 3060,
	"./lente-barra-ricerca.svg": 126,
	"./logo.png": 4427,
	"./male_front.png": 1289,
	"./mappa.png": 9700,
	"./modifica.png": 6759,
	"./pencile.png": 1516,
	"./privacy.png": 1256,
	"./profile.png": 1989,
	"./red.png": 6156,
	"./search.png": 7561,
	"./sottoscrizioni.jpg": 711,
	"./sposta-apri.png": 8085,
	"./taccuino/dolore_bianco.png": 5709,
	"./taccuino/dolore_blu.png": 9175,
	"./taccuino/dolore_porpora.png": 733,
	"./taccuino/dolore_rosso.png": 447,
	"./taccuino/dolore_verde.png": 4107,
	"./taccuino/dolore_viola.png": 6890,
	"./taccuino/female_back.png": 5724,
	"./taccuino/female_back_.png": 8913,
	"./taccuino/female_front.png": 4287,
	"./taccuino/female_front_.png": 5134,
	"./taccuino/human.gif": 8879,
	"./taccuino/human.png": 6655,
	"./taccuino/male_back.png": 1195,
	"./taccuino/male_back_.png": 1902,
	"./taccuino/male_front.png": 3892,
	"./taccuino/male_front_.png": 8927,
	"./taccuino/nuovo_dolore_bianco.png": 1239,
	"./taccuino/nuovo_dolore_verde.png": 2216,
	"./x.png": 1225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;